import { ApsAssignedList } from 'src/app/models/aps-assigned-list';
import { ApsAssignedAction, ApsAssignedActionTypes } from './aps_assinged.actions';

export function ApsAssignedReducers(state = [], action: ApsAssignedAction): Array<ApsAssignedList> {
  switch (action.type) {
    case ApsAssignedActionTypes.LoadApsAssigned: {
      return action.payload;
    }
    default:
      return state;
  }
}
